import { apiSlice } from "./apiSlice";
import {
  GetAuditLogsParams,
  PaginatedAuditLogsResponse,
} from "../../services/audit/audit.types";

/**
 * Audit log list query. The whole filter set (plus page/limit) is the cache
 * key, so RTK Query serves each combination from its own cache entry and a
 * slow response for an old filter can never overwrite a newer one (the
 * anti-race guard the old useEffect version lacked).
 */
export const auditApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAuditLogs: builder.query<PaginatedAuditLogsResponse, GetAuditLogsParams>(
      {
        query: (params) => ({
          url: "/audit-logs",
          method: "GET",
          params,
        }),
        providesTags: [{ type: "AuditLog", id: "LIST" }],
      },
    ),
  }),
});

export const { useGetAuditLogsQuery } = auditApi;
